import { useRef, useCallback, useEffect, useContext, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Route, Routes, useNavigate } from 'react-router-dom'

import { Spinner } from 'core/components'
import routes from 'core/routes'
import { api } from 'core/services'
import { orulTokenManager } from 'core/services/orul-token-manager'

import { TermContext } from 'providers/terms'

import { Actions, TRootReducer } from 'store'

import { ConsoleLayout } from './layout'
import { consoleViewsRoutes } from './views'
import { OrgsView } from './views/Orgs'
import { UserProfile } from './views/UserProfile'

function ConsoleModule() {
  const { app, user } = useSelector((state: TRootReducer) => state)
  const { getUpdates } = useContext(TermContext)
  const userRef = useRef(user)
  const [termsFetched, setTermsFetched] = useState(false)
  /**
   * Sem organização o perfil não pode ser uma rota.
   *
   * A rota raiz é `/:key?/*`: navegar para `/user-profile` faria o React Router casar
   * `:key = "user-profile"`, o `App` chamaria `fetchOrgSettings('user-profile')`, tomaria 404 e
   * deslogaria o usuário. Por isso, nesse estado, o perfil é alternado por estado local — sem
   * mexer na URL. Com organização selecionada ele continua sendo rota normal.
   */
  const [perfilSemOrg, setPerfilSemOrg] = useState(false)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const fetchUserData = useCallback(async () => {
    if (app.currentOrg?.token) {
      try {
        // Token do Orul Auth já está disponível via orulTokenManager
        const [{ data: userData }] = await Promise.all([
          api
            .get(
              routes.api.user.find(
                userRef.current.attributes.phone_number.replace('+', ''),
              ),
              {
                headers: {
                  'X-App-Token': app.currentOrg?.token as string,
                },
              },
            )
            .catch(() => Promise.resolve({ data: { total_scores: 0 } })),
          // axios.get<any[]>(`${process.env.REACT_APP_API_SWAP_URL}/intents`, {
          //   params: {
          //     provider: '@rhaimes/toty',
          //   },
          //   headers: {
          //     authorization: `Bearer ${token}`,
          //   },
          // }),
        ])

        dispatch(
          Actions.user.setData({
            scores: userData.total_scores,
            // intents: userIntents,
          }),
        )
      } catch {
        // if (error instanceof AxiosError) {
        //   // const response = error.response as AxiosResponse<any>
        //   // toast.error(response.data.message as string, { isLoading: true })
        //   // setTimeout(() => {
        //   //   window.location.href = '/'
        //   // }, 3000)
        // }
        // dispatch(Actions.user.setData({ scores: 0 }))
      }
    }
    return 'failed'
  }, [app.currentOrg?.token, dispatch])

  useEffect(() => {
    if (termsFetched) {
      fetchUserData()
    }
  }, [fetchUserData, termsFetched])

  useEffect(() => {
    const token = orulTokenManager.getToken()
    if (token && app.currentOrg?.settings.key) {
      getUpdates(app.currentOrg?.settings.key, token).then(data => {
        if (data.updates) {
          window.location.href = data.url
        } else {
          setTermsFetched(true)
        }
      })
    } else if (!token) {
      // Se não tiver token, marca como fetched para não ficar em loading infinito
      setTermsFetched(true)
    }
  }, [app.currentOrg?.settings.key, getUpdates])

  // O perfil é o único caminho para trocar o telefone, e quem ficou sem empresa vinculada
  // precisa dele justamente para se desbloquear.
  const abrirPerfil = useCallback(() => {
    if (app.currentOrg) {
      navigate(`/${app.key}${routes.app.console.userProfile}`)
      return
    }

    setPerfilSemOrg(true)
  }, [app.currentOrg, app.key, navigate])

  return (
    <ConsoleLayout showTabBar={!!app.currentOrg} onAvatarClick={abrirPerfil}>
      {!app.fetched || (app.currentOrg && !termsFetched) ? (
        <Spinner />
      ) : !app.currentOrg ? (
        perfilSemOrg ? (
          <UserProfile onBack={() => setPerfilSemOrg(false)} />
        ) : (
          <OrgsView />
        )
      ) : (
        <Routes>
          {consoleViewsRoutes.map(({ index, path, element }, key) => (
            <Route
              key={key}
              index={index}
              path={index ? undefined : path}
              element={element}
            />
          ))}
        </Routes>
      )}
    </ConsoleLayout>
  )
}

export { ConsoleModule }
